/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ManufactureItemListTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const manufactureItemListResetTimestamp = (
  state,
  { procType, currentPage, sorts, filters, pageSize }
) => ({
  ...state,
  procType: procType || state.procType,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  // selectedDocuments: INITIAL_STATE.selectedDocuments,
  toStorageBinOptions: INITIAL_STATE.toStorageBinOptions,
  toStorageBinOption: INITIAL_STATE.toStorageBinOption
});

export const manufactureItemListFetchListLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const manufactureItemListFetchListSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const manufactureItemListAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const manufactureItemListRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const manufactureItemListSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ManufactureItemListTypes.MANUFACTURE_ITEM_LIST_RESET_TIMESTAMP]: manufactureItemListResetTimestamp,
  [ManufactureItemListTypes.MANUFACTURE_ITEM_LIST_FETCH_LIST_LOADING]: manufactureItemListFetchListLoading,
  [ManufactureItemListTypes.MANUFACTURE_ITEM_LIST_FETCH_LIST_SUCCESS]: manufactureItemListFetchListSuccess,
  [ManufactureItemListTypes.MANUFACTURE_ITEM_LIST_ADD_SELECTED_DOCUMENTS]: manufactureItemListAddSelectedDocuments,
  [ManufactureItemListTypes.MANUFACTURE_ITEM_LIST_REMOVE_SELECTED_DOCUMENTS]: manufactureItemListRemoveSelectedDocuments,
  [ManufactureItemListTypes.MANUFACTURE_ITEM_LIST_SET_WORKSPACE_VISIBLE]: manufactureItemListSetWorkspaceVisible
});
